"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.theme = void 0;

var _styles = require("@material-ui/core/styles");

var _webfontloader = _interopRequireDefault(require("webfontloader"));

var _LeagueGothicRegular = _interopRequireDefault(require("../../misc/fonts/LeagueGothic-Regular.ttf"));

var _LeagueGothicRegular2 = _interopRequireDefault(require("../../misc/fonts/LeagueGothic-Regular.woff"));

var _LeagueGothicRegular3 = _interopRequireDefault(require("../../misc/fonts/LeagueGothic-Regular.woff2"));

var _palette = _interopRequireDefault(require("./palette"));

var _typography = _interopRequireDefault(require("./typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_webfontloader["default"].load({
  google: {
    families: ['Open Sans:400,600,700', 'sans-serif']
  }
});

var leaguegothicregular = {
  fontFamily: 'League Gothic',
  fontStyle: 'normal',
  src: "local('League Gothic'),\n        local('League-Gothic-Regular'),\n        url(".concat(_LeagueGothicRegular["default"], ") format('ttf'),\n        url(").concat(_LeagueGothicRegular3["default"], ") format('woff2'),\n        url(").concat(_LeagueGothicRegular2["default"], ") format('woff')")
};
var theme = {
  name: 'Light Theme',
  spacing: function spacing(factor) {
    return "".concat(0.5 * factor, "rem");
  },
  palette: _palette["default"],
  typography: _typography["default"],
  props: {
    MuiButtonBase: {
      disableRipple: true
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [leaguegothicregular]
      }
    }
  }
};
exports.theme = theme;

var _default = (0, _styles.createMuiTheme)(theme);

exports["default"] = _default;